import { CountUp } from 'countup.js';

const counters = document.querySelectorAll('.js-count');
let baseOptions = {};

var option = { separator: "'", decimal: '.' };

if (option && typeof option !== 'undefined') {
  baseOptions = option;
}

counters.forEach((counter, i) => {
  const value = counter.getAttribute('data-count');
  const id = 'counter-' + i;
  const isDecimal = Number(value) % 1 !== 0;

  let itemOptions = JSON.parse(JSON.stringify(baseOptions));

  if (counter.dataset.separator) {
    itemOptions.separator = counter.dataset.separator;
  }

  if (isDecimal) {
    itemOptions.decimal = option ? option.decimal : '.';
    itemOptions.decimalPlaces = 1;

    if (counter.dataset.decimal) {
      itemOptions.decimal = counter.dataset.decimal;
    }

  } else {
    delete itemOptions.decimal;
    delete itemOptions.decimalPlaces;
  }

  counter.setAttribute('data-scroll', '');
  counter.setAttribute('id', id);

  const countUp = new CountUp(id, value, itemOptions);

  new ScrollOut({
    treshold: 0.5,
    targets: '#' + id,
    once: true,
    onShown: (el, ctx, scrollingElement) => countUp.start()
  });
});
